export default "__VITE_ASSET__CkszTOkP__"